<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Dashboard</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('clients')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('clients') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('clients') ? 'text-white' : 'kreditgenie-text-green  group-hover:text-white'">Kunden</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('notes')">
        <icon name="book" class="w-4 h-4 mr-2" :class="isUrl('notes') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('notes') ? 'text-white' : 'kreditgenie-text-green  group-hover:text-white'">Notizen</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('pages')">
        <icon name="book" class="w-4 h-4 mr-2" :class="isUrl('pages') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('pages') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Seiten</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('posts')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('posts') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('posts') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Beiträge</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.owner" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Benutzer</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.owner" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('settings')">
        <icon name="settings" class="w-4 h-4 mr-2" :class="isUrl('settings') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('settings') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Einstellungen</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.owner" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('widgets')">
        <icon name="location" class="w-4 h-4 mr-2" :class="isUrl('widgets') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('widgets') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Widgets</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('influencers')">
        <icon name="influencer" class="w-4 h-4 mr-2" :class="isUrl('influencers') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('influencers') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Influencers</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('documents')">
        <icon name="documents" class="w-4 h-4 mr-2" :class="isUrl('documents') ? 'fill-white' : 'kreditgenie-fill-green group-hover:fill-white'" />
        <div :class="isUrl('documents') ? 'text-white' : 'kreditgenie-text-green group-hover:text-white'">Dokumente</div>
      </inertia-link>
    </div>
    <div class="mb-4 absolute bottom-0">
      <inertia-link class="block px-6 py-2 hover:bg-gray-900 hover:text-white text-white" :href="route('users.edit', $page.props.auth.user.id)">Mein Profil</inertia-link>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
